import { authedFetch } from '@features/auth/api/authRefresh'
import type {
  ChangeMasterPasswordRequest,
  ChangeMasterPasswordResponse,
} from '@/crypto/key-hierarchy.types'

/**
 * Master password change REST client (Track E-1)。
 *
 * `PUT /api/users/me/master-password` — JwtAuthGuard 保護のため `authedFetch` 経由
 * (401 retry あり)。レスポンスで新 accessToken を受け取り、sessionStore に反映する
 * のは flow 層の責務 (本 client は wire shape のみ)。
 */
export const changeMasterPassword = (
  request: ChangeMasterPasswordRequest,
): Promise<ChangeMasterPasswordResponse> =>
  authedFetch<ChangeMasterPasswordResponse>('/users/me/master-password', {
    method: 'PUT',
    body: request,
  })
